import classes from '../Pages.module.css';
import { Row, Col, Tabs, Skeleton, message } from 'antd';
import axios from 'axios';
import DataContext from '../../../Context/dataContext';
import { useState, useEffect, useContext } from 'react';
import BasicSalaryDetails from './BasicSalaryDetails';
import SalaryNormDetails from './SalaryNormDetails';
import { useNavigate } from 'react-router';
import SyncLoader from "react-spinners/SyncLoader";
import { useLocation } from "react-router-dom";

const { TabPane } = Tabs;

const SalaryNormCreate = (props) => {

  const employeeData = useContext(DataContext)
  const history = useNavigate();
  const location = useLocation();
  const [editMode, setEditMode] = useState(true)
  const [ad, setAD] = useState(null)
  const [loading, setLoading] = useState(false)
  const [allData, setAllData] = useState(
    {
      "header": {
        "metaData": [
          {
            "name": "salary_norms_hdr_code"
          },
          {
            "name": "state_code"
          },
          {
            "name": "employee_code"
          },
          {
            "name": "department_code"
          },
          {
            "name": "branch_code"
          },
          {
            "name": "designation_code"
          },
          {
            "name": "from_date"
          },
          {
            "name": "to_date"
          },
          {
            "name": "gross_from"
          },
          {
            "name": "gross_to"
          },
          {
            "name": "gross_sal"
          },
          {
            "name": "emp_type"
          }
        ],
        "rows": [
          {
            "state_code": null,
            "employee_code": null,
            "department_code": null,
            "branch_code": null,
            "designation_code": null,
            "from_date": null,
            "to_date": null,
            "gross_from": null,
            "gross_to": null,
            "gross_sal": null,
            "emp_type": null
          }
        ]
      },
      "details": {
        "metaData": [
          {
            "name": "uniq_id"
          },
          {
            "name": "allowance_code"
          },
          {
            "name": "allowance_value"
          },
          {
            "name": "allowance_type_code"
          },
          {
            "name": "allowance_effect"
          },
          {
            "name": "referred_allowance_code"
          },
          {
            "name": "reference_type"
          },
          {
            "name": "condition_allowance_code"
          },
          {
            "name": "condition_sign"
          },
          {
            "name": "condition_value"
          }
        ],
        "rows": []
      }
    }
  );


  useEffect(() => {

    setAD(null)
    axios
      .get(employeeData.URL + '/api/v1/norms/salary-norms/additional-data', {
        withCredentials: true
      })
      .then((response) => {

        console.log(response);
        setAD(ad => {
          let newad = response.data.data
          return ({
            ...newad,
            GENDER: {
              fields: [{ name: "KEY" }, { name: "VALUE" }],
              rows: [{ KEY: "M", VALUE: "Male" }, { KEY: "F", VALUE: "Female" }]
            },
            YESNO: {
              fields: [{ name: "KEY" }, { name: "VALUE" }],
              rows: [{ KEY: "Y", VALUE: "Yes" }, { KEY: "N", VALUE: "No" }]
            },
            ALLOWANCE_TYPE: {
              fields: [{ name: "KEY" }, { name: "VALUE" }],
              rows: [{ KEY: "%", VALUE: "Percentage" }, { KEY: "A", VALUE: "Amount" }]
            },
            ALLOWANCE_EFFECT: {
              fields: [{ name: "KEY" }, { name: "VALUE" }],
              rows: [{ KEY: "+", VALUE: "+" }, { KEY: "-", VALUE: "-" }]
            },
            REFERENCE_TYPE: {
              fields: [{ name: "KEY" }, { name: "VALUE" }],
              rows: [{ KEY: "R", VALUE: "Running Total" }, { KEY: "V", VALUE: "Value" }]
            },
            CONDITION_SIGN: {
              fields: [{ name: "KEY" }, { name: "VALUE" }],
              rows: [
                { KEY: "<", VALUE: "Less Than" },
                { KEY: ">", VALUE: "Greater Than" },
                { KEY: ">=", VALUE: "Greater Than or Equal To" },
                { KEY: "<=", VALUE: "Less Than or Equal To" },
                { KEY: "=", VALUE: "Equal To" },
              ]
            },
          });
        })
      })
      .catch((error) => {
        console.log(error);
      })

  }, [])

  const handleSave = (event) => {

    var formv = true;
    const header = allData.header.rows[0];
    const detail = allData.details.rows[0];

    // Validate header dates
    if (!header?.from_date || !header?.to_date||!detail) {
      message.error({
        content: "Please Fill the Mandatory Fields!!!",
        className: "custom-class",
        style: { marginTop: "1vh" },
      });
      formv = false;
    }
    else if (header.from_date > header.to_date) {
      message.error({
        content: "To date can't be less than from date!!!",
        className: "custom-class",
        style: { marginTop: "1vh" },
      });
      formv = false;
    }
    let count = 0;
    allData.details.rows.forEach(data => {

      if (!data) {

        formv = formv && false
        if (count === 0) {
          message.error({
            content: 'Empty Fields In LEAVE NORM DETAILS Tab!!!',
            className: 'custom-class',
            style: {
              marginTop: '1vh',
            },
          });
        }

        count = count + 1;
      }
    })

    if (formv) {
      console.log("Submitting");
      console.log("Submitting");

      const postData = {
        "header": allData.header.rows,
        "details": allData.details.rows,
      }

      console.log(JSON.stringify(postData, undefined, 2));
      setLoading(true)
      axios
        .post(employeeData.URL + '/api/v1/norms/salary-norms', postData, {
          withCredentials: true,
          credentials: 'include',
        })
        .then((response) => {
          message.success({
            content: 'Salary Norm Created Successfully!!!',
            className: 'custom-class',
            style: {
              marginTop: '2vh',
            },
          });
          setLoading(false)
          history('/payroll/norms/salary-norms')
        })
        .catch((err) => {
          message.error({
            content: 'An Error Occurred!!!!',
            className: 'custom-class',
            style: {
              marginTop: '2vh',
            },
          });
          setLoading(false)
        });
    }

  }

  const handleCancel = (event) => {

    setLoading(false)
    if (location.search === "?allowance") {
      history("/payroll/dashboard");
    } else {
      history('/payroll/norms/salary-norms');
    }

  }

  return (
    ad
      ?
      <Row className={classes['RowP']}>
        <Col lg={editMode ? 13 : 19} md={editMode ? 13 : 19} className={classes['Col']} >

        </Col>
        {
          editMode
            ?
            <>
              <Col md={4} >
                {
                  loading
                    ?
                    <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                    :
                    <button
                      style={{
                        padding: "7px 30px 14px 24px",
                        borderRadius: "50px",
                        background: "transparent",
                        width: "100%",
                        border: "none",
                        outline: "none",
                        fontSize: "16px",
                        fontWeight: "600",
                        lineHeight: "1.5",
                        color: "#071e54",
                        WebkitAppearance: "none",

                        boxShadow:
                          "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                        height: "40px",

                        // Ensure the button takes full width
                      }}
                      onClick={(event) => handleSave(event)}
                      className={classes["ProfileButtonn"]}
                      id="save"
                      onMouseOver={(event) => {
                        event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                      }}
                      onMouseOut={(event) => {
                        event.target.style.boxShadow =
                          "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                      }}
                    >
                      Save
                    </button>
                }

              </Col>
              <Col md={4} >
                {
                  loading
                    ?
                    <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                    :
                    <button
                      style={{
                        padding: "7px 30px 14px 24px",
                        borderRadius: "50px",
                        background: "transparent",
                        width: "100%",
                        border: "none",
                        outline: "none",
                        fontSize: "16px",
                        fontWeight: "600",
                        lineHeight: "1.5",
                        color: "#071e54",
                        WebkitAppearance: "none",

                        boxShadow:
                          "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                        height: "40px",

                        // Ensure the button takes full width
                      }}
                      onClick={(event) => handleCancel(event)}
                      onMouseOver={(event) => {
                        event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                      }}
                      onMouseOut={(event) => {
                        event.target.style.boxShadow =
                          "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                      }}
                      className={classes["ProfileButtonn"]}
                    >
                      Cancel
                    </button>
                }
              </Col>
            </>
            :
            <Col md={4} >
              <button onClick={() => setEditMode(true)} className={classes['ProfileButton']}>Edit Details</button>
            </Col>
        }
        <Col lg={1} md={1} >

        </Col>
        <Col lg={24} md={24} className={classes['Col']}>
          <p></p>
          <div className={classes['EditView']}>
            
              
                <BasicSalaryDetails create={true} ad={ad} setData={setAllData} data={allData.header.rows[0]} editMode={editMode} />
              <Tabs
              centered
              tabPosition="top"
              style={{ display: "flex", justifyContent: "center" }}
              >
                <TabPane tab={<span>Salary Norm Detail</span>} key="0" type="line">
       
                <SalaryNormDetails ad={ad} editMode={editMode} setData={setAllData} data={allData.details.rows} />
              </TabPane>
            </Tabs>
          </div>
        </Col>

      </Row>
      :
      <>
        <Skeleton active={true} />
        <Skeleton active={true} />
        <Skeleton active={true} />
      </>
  );
}

export default SalaryNormCreate